import { useEffect } from 'react';

import * as K from 'common/constants';
import { startSendingMetrics } from 'common/webVitalsReportHandler';

import { useIsLabEnabled } from 'hooks/useIsLabEnabled';

const WebVitalsManager = () => {
  const isWebVitalsLoggerEnabled = useIsLabEnabled(K.LAB.WEB_VITALS_LOGGER);

  useEffect(() => {
    if (isWebVitalsLoggerEnabled) {
      startSendingMetrics();
    }
  }, [isWebVitalsLoggerEnabled]);

  return <></>;
};

export default WebVitalsManager;
